import { Button, Dialog } from '@optimus-web/core';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useRepositoryMutation } from '@mews-commander/data-access';

export const ResetPasswordDialog = ({
    email,
    onClose,
    active,
}: {
    email: string;
    onClose: () => void;
    active: boolean;
}) => {
    const { mutate, isPending } = useRepositoryMutation('users', 'forceResetPassword', {
        onSuccess: () => {
            onClose();
            showSuccessAlert({
                title: <LocalizedText textKey={TextKey.ResetPassword} />,
                description: <LocalizedText textKey={TextKey.ResetPasswordSuccessMessage} />,
            });
        },
    });

    return (
        <Dialog
            title={<LocalizedText textKey={TextKey.ResetPasswordConfirmation} />}
            footer={{
                primary: (
                    <Button size="medium" variant="primary" onClick={() => mutate({ email })} type="submit">
                        <LocalizedText textKey={TextKey.Reset} />
                    </Button>
                ),
                secondary: (
                    <Button size="medium" onClick={onClose} type="submit">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
            }}
            loading={isPending}
            onClose={onClose}
            size="small"
            active={active}
        >
            <LocalizedText textKey={TextKey.ResetPasswordDialogMessage} />
        </Dialog>
    );
};
